export enum MESSAGE_LAYOUT {
	Vertical = "vertical",
	Horizontal = "horizontal",
	List = "list",
	Carousel = "carousel",
}
